<template>
    <div class="page">
        <!--<div v-for="(item,index) in params" :key="index">-->
            <!--<banner :params="item.ad_module.items" v-if="item.module == 'ad_module'"></banner>-->
            <!--<list_media :params="item.comom_module" v-if="item.module == 'comom_module'"></list_media>-->
            <!--&lt;!&ndash;<list_media :params="item.special_module" v-if="item.module == 'special_module'"></list_media>&ndash;&gt;-->
            <!--<icon_module :params="item.icon_module" v-if="item.module == 'icon_module'"></icon_module>-->
            <!--<single_module :params="item.single_module" v-if="item.module == 'single_module'"></single_module>-->

            <!--<time_table :params="item.scheduling_module" v-if="item.module == 'scheduling_module'"></time_table>-->

            <!--<coupon style="margin-top: 10px" :params="item.coupon_module" v-if="item.module == 'coupon_module'"></coupon>-->
        <!--</div>-->
        <van-sticky v-if="0" class="mysticky" style="margin-bottom: 10px">
            <navbar :params="news_params"></navbar>
        </van-sticky>

        <van-pull-refresh v-model="isLoading" @refresh="bindLists(false)">
            <div v-for="(item,index) in params" :key="index">
                <van-sticky  v-if="item.type == 'search'" class="mysticky" style="margin-bottom: 10px">
                    <navbar :params="news_params" :layout="item" :qrcode="qrcode" ></navbar>
                </van-sticky>
                <banner :params="item.banner" v-if="item.type == 'banner'"></banner>
                <icon_module :params="item" v-if="item.type == 'icon_module'"></icon_module>
                <list_live :params="item" v-if="item.type == 'list_live'"></list_live>
                <list_media :params="item" v-if="item.type == 'list_media'"></list_media>
                <single_module :params="item" v-if="item.type == 'single_module'"></single_module>
                <micro_module :params="item" v-if="item.type == 'minivedio'"></micro_module>
                <fm_module :params="item" v-if="item.type == 'fm'"></fm_module>
                <reply_module :params="item" v-if="item.type == 'reply_area'"></reply_module>
            </div>
        </van-pull-refresh>

        <div v-show="!isshowWyplayerPannel && lastCourse.course_id && params.length>0" :class="'last-course my-last-course '+(lastCourse.course_id && isShowLastCourse?'i-as-show':'')" @click="bindGoCurriculum(lastCourse)">
            <div style="position:absolute">
                <div class="last-course-close" @click.stop="bindLastCourseClose">
                    <span class="iconfont iconguanbi1"></span>
                </div>
                <div class="last-course-image">
                    <van-image :src="lastCourse.cover_url"  fit="cover" style="width:35px;height:35px;border-radius: 5px;" />
                </div>
            </div>
            <div class="last-course-name">
                <div class="last-course-col">
                    {{lastCourse.name}}
                </div>
                <div class="last-course-col" v-if="lastCourse.section_name">
                    {{lastCourse.section_name}}
                </div>
            </div>
            <div class="last-course-go">
                进入课程
            </div>
        </div>
    </div>
</template>

<script>
    import banner from '../../components/tabs/banner';
    import list_media from '../../components/tabs/list_media';
    import icon_module from '../../components/tabs/icon_module';
    import single_module from '../../components/tabs/single_module';
    import micro_module from '../../components/tabs/micro_module';
    import time_table from '../../components/tabs/time_table';
    import coupon from '../../components/tabs/coupon';
    import list_live from '../../components/tabs/list_live';
    import fm_module from '../../components/tabs/fm_module';
    import reply_module from '../../components/tabs/reply_module';
    import navbar from '../../components/common/navbar';
    import {PullRefresh,Image as VanImage,Sticky} from 'vant';

    export default {
        name: "index",
        components: {
            banner: banner,
            list_media:list_media,
            icon_module:icon_module,
            single_module:single_module,
            micro_module:micro_module,
            time_table:time_table,
            coupon:coupon,
            list_live:list_live,
            fm_module:fm_module,
            reply_module:reply_module,
            [PullRefresh.name]:PullRefresh,
            navbar:navbar,
            [VanImage.name]:VanImage,
            [Sticky.name]:Sticky
        },
        data(){
            return {
                params:{},
                isLoading:false,
                news_params:{},
                qrcode:{}, // 二维码
                lastCourse:{},
                isShowLastCourse:false,
                scrollTop:0,
                isshowWyplayerPannel:false,
                o_unq:'' // 外部唯一id,合并账号使用
            }
        },
        created() { 
            this.$EventBus.$on('player_pannel_status', target => {
              console.warn("player_pannel_status",target)
              this.isshowWyplayerPannel = target.isshowPannel
            });
        },
        mounted(){
            
            if(!this.util.isLogin()){
                return false;
            }

            window.addEventListener('scroll', this.scrollToTop)
            this.init();

            var u_id = this.util.getQueryStr('u_id') || '';

            if(u_id){
                localStorage.setItem(this.util.token+'_uId',u_id);
            }
            var train_name = this.util.G_CONFIG.train_name?this.util.G_CONFIG.train_name:'首页'
            this.$(document).attr('title',train_name)


            // 合并标记
            this.o_unq = this.util.getQueryStr('o_unq') || '';
            console.log("o_unq",this.o_unq);

            const _this = this
            setTimeout(function(){
              if(_this.o_unq && _this.util.getUserId.get()!==''){
                console.warn("携带了合并标记并登录了,则进行合并数据！！！！");
                _this.merge_users_uniqid()
              }
            },500)
            
            console.log('this.util.G_CONFIG',this.util.G_CONFIG)
            if(this.util.G_CONFIG && this.util.G_CONFIG.yjy_school && this.util.G_CONFIG.yjy_school.school_id){
              // 如果存在则需要进行学生信息绑定操作

              // TODO 去掉原有登录方式
              //this.hasYjyLogin()
            }
        },
        activated(){
            this.GetLastCourse();
            var _self=this;
            this.util.server.mini_message.has_home_unread({
                is_show_load:false,
                callback:function (res) {
                    _self.news_params=res.data
                }
            })

            this.util.server.mini_home.get_user_subscribe({
                is_show_load:false,
                callback:function (res) {
                    _self.qrcode=res.data
                }
            })
        },
        methods: {
            hasYjyLogin(){
              const _this = this
              this.util.server.mini_evaluation.has_yjy_login({
                  data:{},
                  callback:(res=>{
                      const {code, data, msg} = res
                      if(code==1){
                        if(data.has_login==false){
                          _this.gotoYjyLogin()
                        }
                      }
                  })
              })
            },
            gotoYjyLogin(){

              // 设置当前返回地址
              this.util.tempRedirectUrlSch.set(location.href)

              this.$router.replace(this.util.urlPrefix+'/yjy/login?'+'&token='+this.util.token);
            },
            scrollToTop() {
                var _self =this;
                var top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

                if(top <=0){
                    top = 0
                }else if(top > window.innerHeight){
                    top = window.innerHeight;
                }

                if (top > this.scrollTop || top == window.innerHeight) {
                    // console.log('向下滚动');
                    this.isShowLastCourse=false;
                } else {
                    // console.log('向上滚动');
                    this.isShowLastCourse=true;
                }

                setTimeout(function () {
                    _self.scrollTop=top;
                },0)
            },
            init:function () {
                var _self=this;
                this.util.jweixin(function (wx) {
                    _self.util.wxShare(wx, {
                        title: _self.util.G_CONFIG.train_name,
                        desc: _self.util.G_CONFIG.desc,
                        link: location.href+'&u_id='+_self.util.getUserId.get(),
                        imgUrl: _self.util.G_CONFIG.logo
                    });
                });
                this.bindLists(true);
            },

            //新版自定义首页
            bindLists:function(load){
                var _self=this;

                this.util.server.mini_home.index({
                    data: {
                        token: this.util.token
                    },
                    methods: 'get',
                    is_show_load:load,
                    callback: (res => {
                        if (res.code == -1) {
                            return this.util.showToast({
                                message: res.msg,
                            })
                        }

                        var data = res.data.lists;
                        for (var i=0;i<data.length;i++){
                            var item = data[i];

                            //轮播图
                            if(item.type == 'banner'){
                                this.util.tansPics(item.banner, 'img', {
                                    default_img: '',
                                    style: 'w750'
                                });

                                for(var b=0;b<item.banner.length;b++){
                                    var banner = item.banner[b];
                                    if(!banner.course_id || banner.course_id =='') continue;
                                    if(banner.link_type=='knowledge_map'){
                                        banner.link = this.util.urlPrefix+'/knowledge_map/index?knowledge_map_id='+banner.course_id+'&token='+this.util.token;
                                    }else if(banner.link_type=='training'){
                                        banner.link = this.util.urlPrefix+'/training/index?training_id='+banner.course_id+'&token='+this.util.token;
                                    }else if(banner.link_type=='fm'){
                                        banner.link = this.util.urlPrefix+'/fm/index?course_id='+banner.course_id+'&token='+this.util.token;
                                    }else{
                                        banner.link = this.util.getMiniCourseTypeUrl(banner.type,banner.course_id);
                                    }

                                }
                            }

                            //icon
                            if(item.type == 'icon_module'){

                                this.util.tansPics(item.icon_module, 'img', {
                                    default_img: '',
                                    style: 'w128-h128'
                                });

                                for (var c=0;c<item.icon_module.length;c++){
                                    var icon = item.icon_module[c];
                                    if(!icon.link_type && icon.link_type == '') continue;

                                    if(icon.link_type == 'course_list'){
                                        icon.link = this.util.urlPrefix+'/more_list/index?train_layout_id='+item.id+'&module_name='+icon.title+'&index='+c+'&token='+this.util.token;
                                    }else if(icon.link_type == 'course_detail'){
                                        icon.link = this.util.getMiniCourseTypeUrl(6,icon.course_id);
                                    }else if(icon.link_type == 'knowledge_map'){
                                        icon.link = this.util.urlPrefix+'/knowledge_map/index?knowledge_map_id='+icon.knowledge_map_id+'&token='+this.util.token;
                                    }else if(icon.link_type=='training'){
                                        icon.link = this.util.urlPrefix+'/training/index?training_id='+icon.knowledge_map_id+'&token='+this.util.token;
                                    }else if(icon.link_type=='fm'){
                                        icon.link = this.util.urlPrefix+'/fm/index?course_id='+icon.course_id+'&token='+this.util.token;
                                    }
                                }
                            }

                            //课程-列表
                            if(item.type == 'list_live'){

                                if(item.more_box){
                                    item.link = this.util.urlPrefix+'/more_list/index?train_layout_id='+item.id+'&module_name='+item.title+'&token='+this.util.token;
                                }

                                for (var l=0;l<item.list_live.length;l++){
                                    var live = item.list_live[l];

                                    this.util.tansPics(live.info, 'cover_url', {
                                        default_img: '',
                                        style: 'w375'
                                    });

                                    live.link = this.util.getMiniCourseTypeUrl(live.type,live.course_id);
                                }
                            }

                            //课程-小图
                            if(item.type == 'list_media'){

                                if(item.more_box){
                                    item.link = this.util.urlPrefix+'/more_list/index?train_layout_id='+item.id+'&module_name='+item.title+'&token='+this.util.token;
                                }

                                for (var m=0;m<item.list_media.length;m++){
                                    var media = item.list_media[m];

                                    this.util.tansPics(media.info, 'cover_url', {
                                        default_img: '',
                                        style: 'w375'
                                    });

                                    media.link = this.util.getMiniCourseTypeUrl(media.type,media.course_id);
                                }
                            }

                            //课程-大图
                            if(item.type == 'single_module'){

                                if(item.more_box){
                                    item.link = this.util.urlPrefix+'/more_list/index?train_layout_id='+item.id+'&module_name='+item.title+'&token='+this.util.token;
                                }

                                for (var s=0;s<item.single_module.length;s++){
                                    var module = item.single_module[s];

                                    this.util.tansPics(module.info, 'cover_url', {
                                        default_img: '',
                                        style: 'w375'
                                    });

                                    module.link = this.util.getMiniCourseTypeUrl(module.type,module.course_id);
                                }
                            }

                            //小视频
                            if(item.type == 'minivedio'){

                                if(item.more_box){
                                    item.link = this.util.urlPrefix+'/micro/index?'+'?token='+this.util.token;
                                }

                                for (var m=0;m<item.minivedio.length;m++){
                                    var media = item.minivedio[m];

                                    this.util.tansPics(media.info, 'cover_url', {
                                        default_img: '',
                                        style: 'w375'
                                    });

                                    media.link = this.util.getMiniCourseTypeUrl(media.type,media.minivedio_id);
                                }
                            }

                            //FM
                            if(item.type == 'fm'){
                              if(item.more_box){
                                  item.link = this.util.urlPrefix+'/fm/index?course_id='+item.course_id+'&token='+this.util.token;
                              }
                            }
                        }

                        _self.isLoading = false;
                        _self.params = data;
                    })
                })
            },

            //旧版首页
            bindList:function () {
                var _self=this;

                this.util.server.mini_home.index({
                    data:{
                        token: this.util.token
                    },
                    methods:'get',
                    callback: (res => {
                        if(res.code == -1){
                            return this.util.showToast({
                                message: res.msg,
                            })
                        }

                        var data = res.data;
                        for (var d=0;d<data.length;d++){

                            //轮播图
                            if(data[d].ad_module){
                                this.util.tansPics(data[d].ad_module.items, 'images', {
                                    default_img: '',
                                    style: 'w750'
                                });

                                for(var i=0;i<data[d].ad_module.items.length;i++){
                                    data[d].ad_module.items[i]['link'] = this.util.getMiniCourseTypeUrl(data[d].ad_module.items[i].type,data[d].ad_module.items[i].course_id,data[d].ad_module.items[i].p_course_id);
                                }
                            }

                            if(data[d].comom_module){
                                this.util.tansPics(data[d].comom_module.items, 'cover', {
                                    default_img: '',
                                    style: 'w375'
                                });

                                if(data[d].comom_module.link_info.link_name){
                                    data[d].comom_module.link_info.link=this.util.urlPrefix+'/more_list/index?train_layout_id='+data[d].train_layout_id+'&module_name='+data[d].comom_module.module_name+'&token='+this.util.token;
                                }

                                for (var j=0;j<data[d].comom_module.items.length;j++){
                                    data[d].comom_module.items[j]['link'] = this.util.getMiniCourseTypeUrl(data[d].comom_module.items[j].type,data[d].comom_module.items[j].course_id,data[d].comom_module.items[j].p_course_id);
                                }
                            }

                            if(data[d].special_module){
                                this.util.tansPics(data[d].special_module.items, 'cover', {
                                    default_img: '',
                                    style: 'w375'
                                });

                                if(data[d].special_module.link_info.link_name){
                                    data[d].special_module.link_info.link=this.util.getMiniCourseTypeUrl(data[d].special_module.items_type,data[d].special_module.items_params);
                                }

                                for (var k=0;k<data[d].special_module.items.length;k++){
                                    data[d].special_module.items[k]['link'] = this.util.getMiniCourseTypeUrl(data[d].special_module.items[k].type,data[d].special_module.items[k].course_id,data[d].special_module.items[k].p_course_id);
                                }
                            }

                            if(data[d].icon_module){

                                this.util.tansPics(data[d].icon_module.items, 'items_cover', {
                                    default_img: '',
                                    style: 'w128-h128'
                                });

                                for (var l=0;l<data[d].icon_module.items.length;l++){
                                    if(data[d].icon_module.items[l].link_type == '课程列表'){
                                        data[d].icon_module.items[l]['link'] = this.util.urlPrefix+'/more_list/index?train_layout_id='+data[d].icon_module.items[l].train_layout_id+'&module_name='+data[d].icon_module.items[l].name+'&token='+this.util.token;
                                    }else{
                                        data[d].icon_module.items[l]['link'] = this.util.getMiniCourseTypeUrl(data[d].icon_module.items[l].type,data[d].icon_module.items[l].course_id,data[d].icon_module.items[l].p_course_id);
                                    }
                                }
                            }

                            if(data[d].single_module){

                                this.util.tansPics(data[d].single_module.items, 'cover', {
                                    default_img: '',
                                    style: 'w750'
                                });

                                if(data[d].single_module.link_info.link_name){
                                    data[d].single_module.link_info.link=this.util.urlPrefix+'/more_single_list/index?train_layout_id='+data[d].train_layout_id+'&module_name='+data[d].single_module.module_name+'&token='+this.util.token;
                                }

                                for (var m=0;m<data[d].single_module.items.length;m++){
                                    data[d].single_module.items[m]['link'] =this.util.getMiniCourseTypeUrl(data[d].single_module.items[m].type,data[d].single_module.items[m].course_id,data[d].single_module.items[m].p_course_id);
                                }
                            }

                            if(data[d].scheduling_module){

                                this.util.tansPics(data[d].scheduling_module.items, 'items_cover', {
                                    default_img: '',
                                    style: 'w750'
                                });

                                if(data[d].scheduling_module.link_info.link_name){
                                    data[d].scheduling_module.link_info.link=this.util.urlPrefix+'/more_time_table/index?train_layout_id='+data[d].train_layout_id+'&module_name='+data[d].scheduling_module.module_name+'&token='+this.util.token;
                                }

                                for (var n=0;n<data[d].scheduling_module.items.length;n++){
                                    data[d].scheduling_module.items[n]['link'] = this.util.getMiniCourseTypeUrl(7,data[d].scheduling_module.items[n].items_params);
                                }
                            }

                            //优惠券
                            if(data[d].coupon_module){

                                if(data[d].coupon_module.link_info.link_name){
                                    data[d].coupon_module.link_info.link=this.util.urlPrefix+'/coupon/index?train_layout_id='+data[d].train_layout_id+'&module_name='+data[d].coupon_module.module_name+'&token='+this.util.token;
                                }

                                for (var c=0;c<data[d].coupon_module.items.length;c++){
                                    data[d].coupon_module.items[c]['link'] = this.util.urlPrefix+'/coupon/index?train_layout_id='+data[d].train_layout_id+'&module_name='+data[d].coupon_module.module_name+'&token='+this.util.token;
                                }

                            }
                        }

                        _self.params=data;
                    })
                })
            },

            //最后浏览的课程
            GetLastCourse:function () {
                var _self = this;
                this.util.server.mini_home.get_last_course({
                    is_show_load:false,
                    callback: function (res) {
                        if(res.data.course_id){
                            _self.lastCourse=res.data;
                            _self.isShowLastCourse=true;
                        }
                    }
                })
            },
            bindLastCourseClose:function () {
                this.lastCourse={};
            },
            bindGoCurriculum:function (item) {
              if(item.course_type==7){
                 this.$router.push(this.util.urlPrefix+'/fm/index?course_id='+this.lastCourse.course_id+'&token='+this.util.token)
              }else{
                 this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+this.lastCourse.course_id+'&token='+this.util.token)
              }
               
            },
            merge_users_uniqid() {
              const _this = this
              this.util.server.mini_user.merge_users_uniqid({
                  data:{
                      uniqid: this.o_unq
                  },
                  callback: (res =>{
                      const {code,data,msg} = res;
                      
                      if(code==1){
                        console.log("自动合并完成,刷新页面",res)
                        _this.util.logout()
                        return location.reload();
                      }else{
                        console.log("不需要合并",res)
                      }
                  }),
                  is_show_load: false,
                  is_show_error: false,
              })
            }
        },
    }
</script>

<style scoped>
    @supports (bottom: env(safe-area-inset-bottom)) {
      .my-last-course { 
        /* bottom:  50px + env(safe-area-inset-bottom); */
        bottom: calc(50px + env(safe-area-inset-bottom)) !important
      }
    }
    div{
        color: #3a3a3a;
    }
    .page{
        width: 100%;
        height: 100%;
        padding: 12px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .page >>> .van-sticky--fixed{
        background-color: #fff;
        padding: 10px
    }
    .last-course{
        position: fixed;
        bottom: 50px;
        background: rgba(0,0,0,0.75);
        max-width: 480px;
        margin: 0 auto;
        right: 0;
        left: 0;
        border-radius: 5px;
        height: 47px;
        transform:translate3d(0,130%,0);
        -webkit-transition: -webkit-transform 0.3s;
        transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
        transition: transform 0.3s, -webkit-transform 0.3s;
        z-index: 2;
    }
    .i-as-show{
        transform:translate3d(0,0,0);
    }
    .last-course-close{
        display: inline-block;
        padding: 10px;
        vertical-align: top;
    }
    .last-course-close .iconfont{
        font-size: 25px;
        color: #fff;
    }
    .last-course-image{
        display: inline-block;
        font-size: 0;
        height: 41px;
        margin-top: 6px;
        margin-left: 5px;
    }
    .last-course-name{
        display: flex;
        color: #fff;
        width: 100%;
        height: 100%;
        padding-left: 100px;
        box-sizing: border-box;
        align-items: center;
        flex-wrap: wrap;
        padding-right: 80px;
    }
    .last-course-col{
        color: #fff;
        flex: 1 1 100%;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .last-course-go{
        position: absolute;
        top: 50%;
        right: 10px;
        color: #fff;
        padding: 2px 8px;
        border: 1px solid #fff;
        border-radius: 30px;
        font-size: 12px;
        margin-top: -11px;
    }
    .mysticky >>> .van-sticky{
        max-width: 450px;
        margin: 0 auto;
    }
</style>
